import React from 'react';
import { useRouteError } from 'react-router';

// A data router catches render errors and shows its own "Unexpected Application Error!" page (with the stack),
// so they would no longer reach the global error handlers (Sentry). Rethrowing keeps the pre-data-router behaviour.
const RouteErrorBoundary: React.FC = () => {
  throw useRouteError();
};

export default RouteErrorBoundary;
